module.exports = __webpack_public_path__ + "img/D5.92fcfa3a.svg";